export default {
  checkbox: {
    boxSizing: 'border-box',
    display: 'inline-block',
    position: 'relative',
    margin: '0px 8px 0px 0px'
  },

  label: {
    boxSizing: 'border-box',
    display: 'inline-block',
    cursor: 'pointer',
    margin: '0px 10px',
    height: '32px',
    lineHeight: '32px'
  },
  container: {
    display: 'inline-block',
  },
  disabled: {
    cursor: 'not-allowed',
    backgroundColor: '#ddd',
    color: '#aaa'
  }
};



// WEBPACK FOOTER //
// ./src/Components/Checkbox/style.js